<template>
  <div class="field__input">
    <input   :type="type" :required="required" v-model="query"
           :class="error ? 'is-invalid' : false"
            @keyup="onInput"
           :placeholder="placeholder"/>
    <label class="field__label"  v-text="label"/>
    <div class="clear visible" v-if="isLoading">
      <TheSpinner />

    </div>
    <div class="suggestion_wrap" v-if="suggestions && !error">
      <ul v-if="suggestions.length > 0">
        <li @click="selectAddress(suggestion)" v-for="suggestion in suggestions">
          <div>
            <b>{{ suggestion.showText }}</b><br>
            <span style="font-size: 12px; color: #676767">{{suggestion.fullText}}</span>
          </div>
        </li>
      </ul>

      <ul  v-else>
        <li v-if="isLoading">
          Поиск...
        </li>
        <li v-else>
          По вашему запросу ничего не найдено
        </li>
      </ul>

    </div>
    <!-- <p v-if="error" class="invalid-text" v-text="error"/> -->
    <AlertBox :is-show="error" :message="error" />
  </div>
</template>


<script>

import SuggestionSource from "@/api/SuggestionSource.js";
import TheSpinner from "@/components/TheSpinner.vue";
import {mapState} from "vuex";
export default {
  name: 'TheAddressSuggestionInput',
  components: {TheSpinner},
  data() {
    return {
      isLoading: false,
      query: '',
      suggestions: null,
      inputTimeout: null,
    }
  },
  props: {
    modelValue: [String, Number],

    error: {
      type: String,
      default: null,
      require: false,
    },

    readonly: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },

    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  computed:{
    ...mapState({
      'currentCity': state => state.city.currentCity,
    }),
  },

  watch:{
    modelValue(){
      this.query = this.modelValue;
    }
  },
  methods: {
    selectAddress(suggestion) {
      this.query = suggestion.showText;
      this.suggestions = null;
      this.$emit('selectAddress', suggestion);
    },
    async onInput() {
      this.isLoading = false;
      clearTimeout(this.inputTimeout);
      this.inputTimeout = setTimeout(this.onInputSuggest, 1000)
    },
    async onInputSuggest() {

      this.suggestions = null;
      this.$emit('update:error', null);

      if (!this.currentCity) {
        return;
      }

      if(this.query.length === 0){
        this.suggestions = null;
      }
      this.isLoading = true;
      await this.$API.manager.getSource(SuggestionSource).list({
        'store_id': this.currentCity.store_id,
        query: this.query
      }).then((response) => {
        this.suggestions = response;
      }).catch(() => {
        this.suggestions = null;
      }).finally(() => {
        this.isLoading = false;
      })
    }
  }
};
</script>
<style scoped>
.field__input{
  position: relative;
}
.suggestion_wrap{
  position: absolute;
  z-index: 100;
  background: white;
  width: 100%;
}
.suggestion_wrap ul{
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 10px;
  max-height: 200px;
  overflow-y: scroll;
  border-radius: 12px;
  border: 1px solid #DCDDE0;
  margin-top: 10px;
}

.suggestion_wrap li{
  cursor: pointer;
  padding: 5px;
}

.suggestion_wrap li:hover{
  cursor: pointer;
  background: #DCDDE0;
}
</style>
